import React from 'react'
import { Stack, StackProps } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

type ItemFieldProps = StackProps & {
  name: string
  actived?: boolean
}

export const ItemField = ({ name, actived = false, ...rest }: ItemFieldProps) => {
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.down('md'))
  const border = `solid 1px ${actived ? theme.palette.primary.main : theme.palette.grey[800]}`
  return (
    <Stack width={matches ? 1 : 1 / 2} >
      <Stack
        {...rest}
        style={{ cursor: 'pointer' }}
        mr={1}
        mt={1}
        minHeight={50}
        borderRadius={1}
        border={border}
        bgcolor={theme.palette.grey[800]}
        justifyContent="center"
        alignItems="center"
      >
        {name}
      </Stack>
    </Stack>
  )
}
